<template>
  <RequestOverview :key="$route.fullPath" />
</template>

<script lang="ts">
import Vue from "vue";
import RequestOverview from "@/components/complaints/container/RequestOverview.vue";
export default Vue.extend({
  components: {
    RequestOverview,
  },
});
</script>
